export const DecimalsCell = ({ value }: { value: any }) => {
    return <span>{1 * 10 ** value}</span>
}
